import * as yup from 'yup';
import { ISuggestion } from '../../common';
import { SuggestionSchema } from './../../common';

export const IGeneralOrderSuggestionSchema = yup.object({
  orders: SuggestionSchema.nullable(),
});

export interface IGeneralOrderSuggestion {
  orders: ISuggestion;
}
